import React from "react";

// App name and environment are passed in at build/run time via env vars.
const APP_NAME = process.env.REACT_APP_APP_NAME?.trim() || "BabaHanks";
const RAW_ENV = (process.env.REACT_APP_ENV?.trim() || "local").toLowerCase();

type EnvKey = "local" | "dev" | "prod";

const ENV_META: Record<EnvKey, { label: string; color: string }> = {
    local: { label: "LOCAL", color: "#2563eb" }, // blue
    dev: { label: "DEV", color: "#d97706" },      // amber
    prod: { label: "PROD", color: "#dc2626" },    // red
};

// Normalize common spellings to one of the known keys.
const envKey: EnvKey =
    RAW_ENV.startsWith("prod")
        ? "prod"
        : RAW_ENV.startsWith("dev")
        ? "dev"
        : "local";

const meta = ENV_META[envKey];

const EnvBanner: React.FC = () => (
    <div style={barStyle}>
        <span style={{ fontWeight: 600 }}>{APP_NAME}</span>
        <span style={{ ...badgeStyle, background: meta.color }}>{meta.label}</span>
    </div>
);

const barStyle: React.CSSProperties = {
    display: "flex",
    alignItems: "center",
    gap: "0.6rem",
    padding: "0.35rem 0.9rem",
    background: "var(--bg-secondary, #f3f4f6)",
    borderBottom: "1px solid var(--border-color, #e5e7eb)",
    fontSize: "0.9rem",
    color: "var(--text-primary, #111827)",
};

const badgeStyle: React.CSSProperties = {
    color: "#fff",
    fontSize: "0.7rem",
    fontWeight: 700,
    letterSpacing: "0.04em",
    padding: "0.1rem 0.5rem",
    borderRadius: "999px",
};

export default EnvBanner;
